import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {of} from 'rxjs';
import {delay} from 'rxjs/operators';
import {Attachment} from "../../attachment-manager/attachment-manager.component";
import {CkmService} from "../../../services/ckm.service";


@Component({
    selector: 'app-ckm-simulation-create-stepper',
    templateUrl: './ckm-simulation-create-stepper.component.html',
    styleUrls: ['./ckm-simulation-create-stepper.component.scss'],
    standalone: false
})
export class CkmSimulationCreateStepperComponent implements OnInit {
  @Input() projectId: any;

  // EventEmitter per segnalare i vari step
  @Output() stepChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() generationStarted: EventEmitter<void> = new EventEmitter<void>();
  @Output() generationCompleted: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigation: EventEmitter<string> = new EventEmitter<string>();

  firstFormGroup: FormGroup;
  generationComplete = false;
  generatedSimulationID = null;

  // Proprietà per memorizzare gli allegati
  attachments: Attachment[] = [];

  constructor(private _formBuilder: FormBuilder, private router: Router, private ckmservice: CkmService) {
  }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      description: ['']
    });
  }

  /**
   * Aggiorna la lista degli allegati ricevuta dal componente Attachment Manager
   */
  onAttachmentsChange(updatedAttachments: Attachment[]): void {
    this.attachments = updatedAttachments;
  }

  startGeneration(): void {
    this.generationStarted.emit();
    const data = {
      ...this.firstFormGroup.value,
      attachments: this.attachments,
    };
    of(true)
      .pipe(delay(3000))
      .subscribe(() => {
        this.ckmservice.createCkmSimulation(this.projectId, data, (response) => {
          this.generationComplete = true;
          this.generatedSimulationID = response?.simulation?.id;
          this.generationCompleted.emit();
        });
      });
  }

  onStepChange(event: any): void {
    this.stepChanged.emit(event.selectedIndex);
    if (event.selectedIndex === 1 && !this.generationComplete) {
      this.startGeneration();
    }
  }

  navigateToPage(): void {
    this.navigation.emit('/ckm-simulation');
    this.router.navigate(['/ckm-simulations', this.generatedSimulationID]);
  }
}
